export enum ReportType {
    TREND = 'trend',
    COMPARE = 'compare',
}
